<template>
  <div class="dialer-call-bar tw-p-3 tw-rounded tw-mb-3">
    <div class="tw-font-medium tw-truncate">{{ who }}</div>
    <div class="tw-text-sm tw-text-gray-600">{{ statusLabel }}</div>

    <BaseButton
      v-if="call.status === 'ringing'"
      variant="inverted-primary"
      size="small"
      class="tw-mt-3"
      @click="$store.dispatch('dialer/wrapUp')"
    >
      Wrap up
    </BaseButton>
  </div>
</template>

<script>
import { BaseButton } from '@bambeehr/pollen';
import { mapState } from 'vuex';

const STATUS_LABELS = {
  calling: 'Starting the call…',
  ringing: 'Ringing in your Dialpad app. Press Wrap up when you hang up.',
  wrapup: 'Call ended',
};

export default {
  name: 'DialerCallBar',

  components: {
    BaseButton,
  },

  computed: {
    ...mapState('dialer', { call: 'activeCall' }),

    who() {
      return this.call.name || this.call.phone;
    },

    statusLabel() {
      return STATUS_LABELS[this.call.status];
    },
  },
};
</script>

<style lang="scss" scoped>
.dialer-call-bar {
  background: #f4f0f8;
}
</style>
